{
    "convercusProgramId": "con",
    "integration": null,
    "platform": "ios",
    "levelKey": "Gold",
    "appearance": {
        "balanceName": "Points",
        "icon": "https://example.com/icon.png",
        "passLogo": "",
        "bannerImage": "",
        "backgroundColor": "#FFD700",
        "foregroundColor": "#333333"
    },
    "scannableCode": {
        "type": "qr",
        "previewMessage": "acc-demo-001"
    },
    "mockPayload": {
        "name": "",
        "balance": 100,
        "tierStatus": "Gold"
    },
    "apple": {
        "omitPointsAndBalanceSemantics": false,
        "headerFields": [
            {
                "key": "balance",
                "label": "Points",
                "value": 100
            }
        ],
        "secondaryFields": [
            {
                "key": "tier",
                "label": "Tier",
                "value": "Gold"
            }
        ],
        "auxiliaryFields": [],
        "barcodeAltText": "acc-demo-001"
    },
    "google": {
        "omitPrimaryLoyaltyPoints": false,
        "issuerName": "\u200b",
        "programName": "\u200b",
        "loyaltyPointsLabel": "Points",
        "loyaltyPointsBalance": "100",
        "secondaryLoyaltyPointsLabel": "Tier",
        "secondaryLoyaltyPointsBalance": "Gold",
        "textModules": [],
        "barcodeAlternateText": "acc-demo-001"
    }
}
